import React from 'react';
import Tailan from './SanhuugiinTailan';

const PageList = () => <Tailan />;

export default PageList;
